<template>
  <div class="aside-inner">
    <section class="m-b-30">
     <div class="field">
     </div>
   </section>
   <section class="m-b-30 single-aside-details--data is-hidden-mobile">
     <fieldset disabled>
       <div class="field">
         <label class="label">Pitch Date</label>
         <div class="control">
           <input class="input" type="text" v-bind:value="pitch.date | moment-date">
         </div>
       </div>
      <div v-if="pitch.email">
        <div style="display: flex; gap: 8px;">
          <label class="label">Password</label>
          <a v-if="canEditEmailPassword(pitch.email)" class="tooltip" style="margin-top: 3px !important;" :data-tooltip="pitch.email.password_protected ? 'Edit Password' : 'Add Password'" @click="editPassword(pitch.email)">
            <IconEdit style="width: 15px; height: 15px;"/>
          </a>
          </div>
         <div class="control">
           <p style="font-size: 0.85rem;">{{ pitch.email.password }}</p>
         </div>
       </div>
       <div class="field" v-if="pitch.playlist">
         <label class="label">Playlist</label>
         <div class="control">
           <input class="input" type="text" v-bind:value="pitch.playlist | orBlank('title')">
         </div>
        <div class="field m-t-5" style="display: flex; gap: 8px;">
          <label class="label">Playlist Password</label>
          <a v-if="canEditEmailPassword(pitch.pitch_group_emails[0])" class="tooltip" style="margin-top: 3px !important;" :data-tooltip="pitch.pitch_group_emails[0].password_protected ? 'Edit Password' : 'Add Password'" @click="editPassword(pitch.pitch_group_emails[0])">
            <IconEdit style="width: 15px; height: 15px;"/>
          </a>
          </div>
         <div class="control">
           <p style="font-size: 0.85rem;">{{ pitch.pitch_group_emails[0].password }}</p>
         </div>
       </div>
     </fieldset>
   </section>
   <section class="m-b-30 single-aside-details--tags is-hidden-mobile">
     <label class="label">Tags</label>
     <tag-control taggableType="pitch" :taggableId="pitch.id" />
   </section>
    <form-modal
      type="editEmailPassword"
      :title="formTitle"
      :model="selectedEmail"
      :isModal="isModal"
      v-on:clear-modal="clearModal"
      v-on:save-record="save"
    ></form-modal>
  </div>
</template>

<script>
import { IconEdit } from '@/Icons/IconBase'
import { EMAIL_UPDATE, PITCH_READ } from '@/store/actions'
export default {
  name: 'AsidePitch',
  props: {
    pitch: Object
  },
  components: {
    IconEdit
  },
  data() {
    return {
      formTitle: 'Edit Password',
      isModal: false,
      selectedEmail: {}
    }
  },
  computed: {
    canEditEmailPassword() {
      return (email) => {
        let currentUser = Object.assign({}, this.$store.getters.getProfile)
        return email.created_by_user_id === currentUser.id
      }
    }
  },
  methods: {
    editPassword(email) {
      this.selectedEmail = email
      this.isModal = !this.isModal
      this.formTitle = 'Edit Password'
    },
    clearModal() {
      this.isModal = false
    },
    save(data) {
      this.$store.dispatch(EMAIL_UPDATE, {
        id: this.selectedEmail.id,
        data: data
      }).then(() => {
        this.$store.dispatch(PITCH_READ, this.pitch.id)
      })
      this.clearModal()
    }
  }
}
</script>
